export const ADD_LOG_ELEMENT_TO_TICKET_LOGS = 'ADD_LOG_ELEMENT_TO_TICKET_LOGS';
export const UPDATE_TICKET_LOG_BY_WS = 'UPDATE_TICKET_LOG_BY_WS';
export const CREATE_NOTE = 'CREATE_NOTE';
export const CREATE_NOTE_FAILURE = 'CREATE_NOTE_FAILURE';
export const DELETE_NOTE = 'DELETE_NOTE';
export const DELETE_NOTE_FAILURE = 'DELETE_NOTE_FAILURE';
export const DELETE_NOTE_SUCCESS = 'DELETE_NOTE_SUCCESS';
export const DELETE_REASON = 'DELETE_REASON';
export const DELETE_REASON_FAILURE = 'DELETE_REASON_FAILURE';
export const DELETE_REASON_SUCCESS = 'DELETE_REASON_SUCCESS';
export const EDIT_NOTE = 'EDIT_NOTE';
export const EDIT_NOTE_FAILURE = 'EDIT_NOTE_FAILURE';
export const EDIT_NOTE_SUCCESS = 'EDIT_NOTE_SUCCESS';
export const FETCH_LOG_IF_NOT_FETCHED_YET = 'FETCH_LOG_IF_NOT_FETCHED_YET';
export const FETCH_LOGS_BY_CLIENT = 'FETCH_LOGS_BY_CLIENT';
export const FETCH_LOGS_BY_TICKET = 'FETCH_LOGS_BY_TICKET';
export const FETCH_LOGS_FAILURE = 'FETCH_LOGS_FAILURE';
export const FETCH_REASONS = 'FETCH_REASONS';
export const FETCH_REASONS_FAILURE = 'FETCH_REASONS_FAILURE';
export const FETCH_REASONS_SUCCESS = 'FETCH_REASONS_SUCCESS';
export const FETCH_SEGMENTS = 'FETCH_SEGMENTS';
export const FETCH_SEGMENTS_FAILURE = 'FETCH_SEGMENTS_FAILURE';
export const FETCH_SEGMENTS_SUCCESS = 'FETCH_SEGMENTS_SUCCESS';
export const FLAG_NOTE = 'FLAG_NOTE';
export const FLAG_NOTE_FAILURE = 'FLAG_NOTE_FAILURE';
export const FLAG_NOTE_SUCCESS = 'FLAG_NOTE_SUCCESS';
export const OPEN_COMMUNICATION = 'OPEN_COMMUNICATION';
export const OPEN_COMMUNICATION_FAILURE = 'OPEN_COMMUNICATION_FAILURE';
export const PIN_NOTE = 'PIN_NOTE';
export const PIN_NOTE_FAILURE = 'PIN_NOTE_FAILURE';
export const PIN_NOTE_SUCCESS = 'PIN_NOTE_SUCCESS';
export const SET_FILTERS = 'SET_LOGS_FILTERS';
export const SET_LOGS = 'SET_LOGS';
export const SET_LOGS_META = 'SET_LOGS_META';
export const SET_PAGE = 'SET_LOGS_PAGE';
export const SET_RELATION = 'SET_RELATION';
export const SET_TICKET_LOGS = 'SET_TICKET_LOGS';
export const SUBMIT_REASON = 'SUBMIT_REASON';
export const SUBMIT_REASON_FAILURE = 'SUBMIT_REASON_FAILURE';
export const SUBMIT_REASON_SUCCESS = 'SUBMIT_REASON_SUCCESS';
export const UPDATE_LOG = 'UPDATE_LOG';
export const LOG_STATUS = 'LOG_STATUS';
export const TOGGLE_TICKET_LOGS_GROUP = 'TOGGLE_TICKET_LOGS_GROUP';
export const DELETE_LOG_ATTACHMENT = 'DELETE_LOG_ATTACHMENT';
export const DELETE_LOG_ATTACHMENT_SUCCESS = 'DELETE_LOG_ATTACHMENT_SUCCESS';

// TODO: Refactor params

export const fetchLogsByClient = payload => ({
  payload,
  type: FETCH_LOGS_BY_CLIENT,
});

export const fetchLogsByTicket = payload => ({
  payload,
  type: FETCH_LOGS_BY_TICKET,
});

export const createNote = payload => ({ payload, type: CREATE_NOTE });

export const editNote = payload => ({ payload, type: EDIT_NOTE });

export const pinNote = payload => ({ payload, type: PIN_NOTE });

export const flagNote = payload => ({ payload, type: FLAG_NOTE });

export const deleteNote = payload => ({ payload, type: DELETE_NOTE });

export const setFilters = payload => ({ payload, type: SET_FILTERS });

export const setPage = payload => ({ payload, type: SET_PAGE });

export const submitReason = payload => ({ payload, type: SUBMIT_REASON });

export const deleteReason = payload => ({ payload, type: DELETE_REASON });

export const setRelation = payload => ({ payload, type: SET_RELATION });

export const openCommunication = payload => ({
  payload,
  type: OPEN_COMMUNICATION,
});

export const toggleTicketLogsGroup = payload => ({
  payload,
  type: TOGGLE_TICKET_LOGS_GROUP,
});

export const deleteLogAttachment = payload => ({
  payload,
  type: DELETE_LOG_ATTACHMENT,
});
